module.exports = __webpack_public_path__ + "static/sportovni-odpoledne-na-czu-05-7ce4dfa50e1d14fda030acb6a5f8d43a.jpg";